export const defaultAttachmentProps = {
  webChatAttachmentId: "oc-lcw-webchat-attachment",
  adaptiveCardAttachmentId: "ms_lcw_webchat_adaptive_card",
  enableInlinePlaying: true
};